import Script from 'next/script';
import { message } from 'antd';
import { useDispatch, useSelector } from 'react-redux';

import { setGoogleMapsApiLoaded } from '@lib/redux.lib/slices/appSlice';
import type { RootState } from '@lib/redux.lib/store';

export const GoogleMapsApi = () => {
  const { loaded } = useSelector((state: RootState) => state.app.googleMapsApi);
  const dispatch = useDispatch();
  const handleGoogleMapsLoaded = () => {
    dispatch(setGoogleMapsApiLoaded(true));
  };

  if (typeof window !== 'undefined') {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    window.handleGoogleMapsLoaded = handleGoogleMapsLoaded;
  }
  return !loaded ? (
    <Script
      type='text/javascript'
      src={`https://maps.googleapis.com/maps/api/js?key=${process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY}&libraries=places&loading=async&callback=handleGoogleMapsLoaded`}
      onError={(googleMapsError) => {
        console.log({ googleMapsError });
        message.error(
          'Google Maps API failed to load. Please refresh the page.'
        );
      }}
    />
  ) : (
    <></>
  );
};
